module.exports = __webpack_public_path__ + "static/media/directo.29b76070.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/directo.png
// module id = 931
// module chunks = 0